import { useTreasureApi, ApiKeys } from 'hooks/api/use-treasure-api';
import { useQuery, UseQueryResult } from 'react-query';
import { ReactQueryKeys } from 'enums';

export const useDashboardActivity = (): UseQueryResult<any> => {
  const { treasureApi } = useTreasureApi(ApiKeys.Banking);

  return useQuery([ReactQueryKeys.DashboardActivity], async () => {
    const response = await treasureApi().get('/dashboard/activity');

    return response.data;
  });
};
